import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import App from './App';

import '../../../css/homeHeader/homeHeader.scss';

const gamesSearchPageId = 'home-header';

ready(() => {
  render(<App />, document.getElementById(gamesSearchPageId));
});
